// removed by extract-text-webpack-plugin
module.exports = {"changeSizeBtnWrapper":"changeSizeBtnWrapper__2wk2U","changeSizeBtn":"changeSizeBtn__bvmku","selectionText":"selectionText__23znl","pageSizeModal":"pageSizeModal__eUyVp"};


//////////////////
// WEBPACK FOOTER
// ./components/dropList/style.scss
// module id = K9v/
// module chunks = 0